import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));

export const classNames = (...classes: ClassName[]) =>
  classes.filter(Boolean).join(" ");

type ClassName = string | boolean;
